module.exports = __webpack_public_path__ + "img/cam_9_on.299103b9.png";